// 文章閱讀進度條功能
document.addEventListener('DOMContentLoaded', function() {
  const progressBar = document.getElementById('reading-progress');
  const articleContent = document.getElementById('article-content');
  
  if (!progressBar || !articleContent) {
    console.log('Progress bar: Required elements not found');
    return;
  }
  
  // 計算文章內容的實際高度和位置
  function calculateProgress() {
    // 獲取文章內容的位置信息
    const articleRect = articleContent.getBoundingClientRect();
    const articleTop = articleRect.top + window.pageYOffset;
    const articleHeight = articleRect.height;
    
    // 計算可滾動的總高度（文章高度減去視窗高度）
    const scrollableHeight = articleHeight - window.innerHeight;
    
    // 計算當前滾動位置相對於文章開始的位置
    const currentScroll = window.pageYOffset - articleTop + window.innerHeight;
    
    // 計算進度百分比
    let progress = 0;
    if (currentScroll > 0 && scrollableHeight > 0) {
      progress = (currentScroll / (articleHeight)) * 100;
      progress = Math.min(100, Math.max(0, progress));
    }
    
    // 更新進度條寬度
    progressBar.style.width = progress + '%';
    
    // 添加視覺反饋
    if (progress >= 100) {
      progressBar.style.backgroundColor = '#00d4aa'; // 完成時顏色稍微亮一點
    } else {
      progressBar.style.backgroundColor = '#00AF9A'; // 預設顏色
    }
  }
  
  // 節流函數，優化性能
  let ticking = false;
  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        calculateProgress();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  // 監聽滾動事件
  window.addEventListener('scroll', handleScroll);
  
  // 監聽視窗大小變化
  window.addEventListener('resize', calculateProgress);
  
  // 初始化進度
  calculateProgress();
  
  // 頁面載入完成後重新計算（確保圖片等資源載入完成）
  window.addEventListener('load', function() {
    setTimeout(calculateProgress, 100);
  });
});